<script>

    import { toast } from 'bulma-toast'
    import { locationsStore, modalStore } from '../stores'

    import LocationsService from '../$services/locations.service'

    import InputText from '../$components/input.text.svelte'
    import Spinner from '../$components/spinner.svelte'
    import Message from '../$components/message.svelte'
    import Event from '../$components/event.svelte'

    import Pagination from '../$components/pagination.svelte'

    let loading = false
    let element = null
    let metadata = {}
    let query = {
        page: 0
    }

    getLocations()

    async function getLocations() {

        loading = true
        const resp = await LocationsService.getLocations(query)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        locationsStore.set(resp.data.locations)
        metadata = resp.data.metadata
    }

    async function updateLocationDefault(location) {

        loading = true
        const resp = await LocationsService.updateLocationDefault(location._id)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        getLocations()
    }

    async function getLocationsReport() {

        loading = true
        const blob = await LocationsService.getLocationsReport()
        loading = false

        if(!blob)
            toast({message: resp.error.message, type: 'is-danger'})

        element.download = `mis_direcciones.csv`
        element.href = window.URL.createObjectURL(blob)
        element.click()
    }

</script>

<a bind:this={element} style="display: none;" href="/">.</a>

<Event event="LocationsUpdated" on:dispatch={ getLocations } />

<div class="columns">
    <div class="column">
        <InputText on:enter={ getLocations } bind:value={ query.find } placeholder="Buscar" icon="search" />
    </div>
    <div class="column is-narrow">
        <button on:click={() => getLocationsReport()} class="button">
            <span class="icon"><i class="fas fa-file"></i></span>
            <span>Descargar direcciones</span>
        </button>
    </div>
    <div class="column is-narrow">
        <button on:click={() => modalStore.set('location_upload_modal')} class="button">
            <span class="icon"><i class="fas fa-plus"></i></span>
            <span>Subir direcciones</span>
        </button>
    </div>
    <div class="column is-narrow">
        <button on:click={() => modalStore.set('location_create_modal')} class="button">
            <span class="icon"><i class="fas fa-plus"></i></span>
            <span>Crear dirección</span>
        </button>
    </div>
</div>

<div class="items-space space-bottom">
    <small>
        { (parseInt(query.page) * 100) + $locationsStore.length } 
        {#if metadata.total}
            / {metadata.total}
        {/if}
        Resultados
    </small>
    <Pagination bind:metadata bind:page={ query.page } on:change={ getLocations } />
</div>

<Spinner {loading} />
<Message show={!loading && !$locationsStore.length} />

{#if !loading && $locationsStore.length}
    <div class="table-container">
        <table class="table is-fullwidth is-hoverable">
            <thead>
                <tr>
                    <th></th>
                    <th>
                        <div class="icon-text">
                            <span class="icon">
                              <i class="fas fa-address-book"></i>
                            </span>
                            <span>Alias</span>
                        </div>
                    </th>
                    <th>
                        <div class="icon-text">
                            <span class="icon">
                              <i class="fas fa-user"></i>
                            </span>
                            <span>Contacto</span>
                        </div>
                    </th>
                    <th>
                        <div class="icon-text">
                            <span class="icon">
                              <i class="fas fa-phone"></i>
                            </span>
                            <span>Teléfono</span>
                        </div>
                    </th>
                    <th>
                        <div class="icon-text">
                            <span class="icon">
                              <i class="fas fa-map-marker-alt"></i>
                            </span>
                            <span>Código postal</span>
                        </div>
                    </th>
                    <th>
                        <div class="icon-text">
                            <span class="icon">
                              <i class="fas fa-city"></i>
                            </span>
                            <span>Ciudad</span>
                        </div>
                    </th>
                    <th>
                        <div class="icon-text">
                            <span class="icon">
                              <i class="fas fa-map-marker-alt"></i>
                            </span>
                            <span>Estado</span>
                        </div>
                    </th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {#each $locationsStore as location}
                    <tr>
                        <td>
                            <div class="field">
                                <input on:click={() => updateLocationDefault(location)} bind:checked={location.default} class="is-checkradio is-primary" id="{location._id}" type="checkbox">
                                <label for="{location._id}"></label>
                            </div>
                        </td>
                        <td>{ location.alias }</td>
                        <td>{ location.contact }</td>
                        <td>{ location.phone }</td>
                        <td>{ location.zipcode }</td>
                        <td>{ location.city }</td>
                        <td>{ location.state }</td>
                        <td>
                            <button on:click={() => modalStore.open('location', 'modal', location)} class="button">
                                <span class="icon"><i class="fas fa-ellipsis-v"></i></span>
                            </button>
                        </td>
                    </tr>
                {/each}
            </tbody>
        </table>
    </div>
{/if}